import React from 'react'

import { usePermissions } from '../../features/authorization/hooks/usePermissions/usePermissions'
import type { RouteGuardProps } from '../routes.types'

import { AccessDenied } from '@/components/common/AccessDenied'

export function PermissionGuard({
    children,
    requiredPermission,
    showError = true,
}: Pick<RouteGuardProps, 'children' | 'requiredPermission'> & { showError?: boolean }) {
    const { can } = usePermissions()

    // If no permission is required, allow access
    if (!requiredPermission) {
        return <>{children}</>
    }

    // Check permission-based access
    const hasPermission = can(requiredPermission.action, requiredPermission.subject)

    if (!hasPermission) {
        if (showError) {
            return (
                <AccessDenied
                    title="Access Denied"
                    message="You don't have the necessary permissions to access this page. Please contact your administrator if you need access to this feature."
                />
            )
        }

        return null
    }

    return <>{children}</>
}
